var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-o enable-page-overlay side-scroll page-header-fixed page-header-dark main-content-narrow",attrs:{"id":"page-container"}},[_c('the-aside'),_c('sidebar'),_c('the-header'),_c('main',{attrs:{"id":"main-container"}},[_c('router-view')],1),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }